import { render, staticRenderFns } from "./RestrictedVisitorsPage.vue?vue&type=template&id=0c124afa"
import script from "./RestrictedVisitorsPage.vue?vue&type=script&lang=js"
export * from "./RestrictedVisitorsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports